import React, { useContext } from "react";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
import { WishListContext } from "../../../context/WishListItems";
import styles from "./NotificationIcon.module.css";

export default function WishlistIcon(props) {
  const { wishItems } = useContext(WishListContext);
  return (
    <>
      <span
        className={`material-icons fw-bold ms-2 ${styles.notifyIcon} ${
          props.wishlistCount ? styles.notifyIconActive : ""
        }`}
        onClick={() => props.handleWishlist()}
        id="icon"
      >
        favorite
        {wishItems?.length > 0 && (
          <CircleRoundedIcon
            sx={{
              border: "1px solid white",
              borderRadius: "50%",
              boxSizing: "border-box",
            }}
            className="CircleRoundedIcon"
          ></CircleRoundedIcon>
        )}
      </span>
      {/* <span
        className="wishList"
        id="number"
        onClick={() => props.handleWishlist()}
      >
        Wishlist
      </span> */}
    </>
  );
}
